import { render } from "./AttrLabel.vue?vue&type=template&id=a8478008&scoped=true"
import script from "./AttrLabel.vue?vue&type=script&lang=js"
export * from "./AttrLabel.vue?vue&type=script&lang=js"

import "./AttrLabel.vue?vue&type=style&index=0&id=a8478008&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8478008"],['__file',"src/components/widgets/components_core/AttrLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8478008"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8478008', __exports__)) {
    api.reload('a8478008', __exports__)
  }
  
  module.hot.accept("./AttrLabel.vue?vue&type=template&id=a8478008&scoped=true", () => {
    api.rerender('a8478008', render)
  })

}


export default __exports__